import React from 'react';
import {IProps} from './types';
import * as S from './styles';

const ToggleSwitch:React.FC<IProps> = (props) => {

  return (
    <S.Root style={props.style}>
        <S.CheckBox id={props.id} type="checkbox" checked={props.checked} onChange={props.onChange}/>
        <S.CheckBoxLabel htmlFor={props.id} active={props.checked && props.activeStyle}/>
    </S.Root>
  );
}

export default ToggleSwitch;